module.exports = __webpack_public_path__ + "img/Location.1e5b336b.svg";